import { PlanType } from '@dtx-company/true-common/src/types/planType'
import { authPromoPlanContent } from './AuthPromoSection.constants'

export function getPlanPromoContent({
  planTypeQueryParams
}: {
  planTypeQueryParams: string | undefined
}): string[] {
  switch (planTypeQueryParams) {
    case PlanType.PRO_FLEX:
      return authPromoPlanContent.growth
    case PlanType.PRO:
      return authPromoPlanContent.pro
    case PlanType.PRO_PLUS_ORG:
      return authPromoPlanContent.proplus
    default:
      return authPromoPlanContent.default
  }
}
